<!--站点一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
         <span class="title">案例管理</span>
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <Input v-model="page.key" placeholder="根据案例名称搜索" @on-enter="search">
          <Button slot="append" icon="ios-search" @click="search"></Button>
        </Input>
        <Button style="margin: 2px 0 0 5px" @click="reset">重置</Button>
      </div>
      <div class="right">
        <Select v-model="page.is_del" style="margin-right: 5px">
          <Option :value="0">未删除</Option>
          <Option :value="1">已删除</Option>
        </Select>

        <Button type="primary"  @click="gotoEdit(0)">新增案例</Button>
      </div>
    </div>
    <Table :columns="columns" :data="data" :loading="tableLoading"/>
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { hasOneOf } from "@/libs/tools";
import excel from "@/libs/excel";
export default {
  data() {
    return {
      page: {
        p: 0,
        l: 10,
        is_del: 0,
        key: ""
      },
      data: [],
      total: 0,
      tableLoading: false,
      columns: [
        { title: "编号", key: "id" },
        { title: "案例名称", key: "name" },
        { title: "权重", key: "solt" },
        {
          title: "操作",
          key: "operator",
          render: (h, data) => {
            return h("div", {}, [
              h(
                "Button",
                {
                  props: {
                    size: "small",
                    type: data.row.is_del ? "success" : "error"
                  },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `是否${data.row.is_del ? "恢复" : "删除"}`,
                        content: `是否${
                          data.row.is_del ? "恢复" : "删除"
                        }该案例`,
                        loading: this.confirmLoading,
                        onOk: () => {
                          this.confirmLoading = true;
                          this.del(data.row.id, data.row.is_del ? 0 : 1);
                        }
                      });
                    }
                  }
                },
                data.row.is_del ? "恢复" : "删除"
              ),
              h(
                "Button",
                {
                  props: { size: "small", type: "warning" },
                  on: {
                    click: () => {
                      this.gotoEdit(data.row.id);
                    }
                  }
                },
                "修改"
              )
            ]);
          }
        }
      ],
      loading: false,
      confirmLoading: false
    };
  },
  methods: {
    search() {
      this.page.p = 0;
      this.getData();
    },
    gotoEdit(id = 0) {
      this.$router.push({ path: "/web/case/edit", query: { id } });
    },
    reset() {
      this.page.p = 0;
      this.page.key = "";
      this.getData();
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    getData() {
      this.tableLoading = true;
      this.WebGetCase(this.page).then(res => {
        this.total = res.total;
        this.data = res.data;
        this.tableLoading = false;
      });
    },
    del(id, is_del) {
      this.WebSaveCase({ id, is_del }).then(res => {
        this.confirmLoading = false;
        this.getData();
      });
    },
    ...mapActions(["WebGetCase", "WebSaveCase"])
  },
  mounted() {
    this.getData();
  },
  computed: mapGetters({
    user: "agent",
    access: "access"
  }),
  watch: {
    "page.is_del"(n, o) {
      this.getData();
    }
  }
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
